var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyU = function SvgKeyU(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4723_70286)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 26.94,
    height: 26.94,
    rx: 1.796,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0029 9.23795H11.2295V14.0262C11.2295 15.5153 12.2292 16.5676 13.9077 16.5676C15.5915 16.5676 16.586 15.5153 16.586 14.0262V9.23795H15.8125V13.9262C15.8125 15.0943 15.0758 15.852 13.9077 15.852C12.7396 15.852 12.0029 15.0943 12.0029 13.9262V9.23795Z",
    fill: "#212B36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.15,
    y: 0.15,
    width: 26.641,
    height: 26.641,
    rx: 1.646,
    stroke: "#212B36",
    strokeWidth: 0.299
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4723_70286",
    x: 0.401,
    y: 0,
    width: 28.138,
    height: 28.736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.599,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow_4723_70286"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.197
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4723_70286"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4723_70286",
    result: "shape"
  })))));
};
export default SvgKeyU;